export const SIGN_SUCESS = "SIGN_SUCESS";

export default {
  SIGN_SUCESS,
};
